import {Col, Row, Button} from 'antd';
import {
  BsCheckLg,
  BsFillArrowLeftCircleFill,
  BsFillTrashFill,
} from 'react-icons/bs';
import {FaTag} from 'react-icons/fa';
import IntlMessages from '../../../../../domain/utility/IntlMessages';
import {useNavigate} from 'react-router-dom';
import {useIntl} from 'react-intl';
import {BannersListDto} from '../../../../../shared/services/banners/dto/banners-list-dto';
import {useLocaleContext} from 'src/domain/utility/AppContextProvider/LocaleContextProvide';

interface ICreateOrEditBannerHeaderProps {
  isSubmitting: boolean;
  saveAndContinue: boolean;
  setSaveAndContinue: any;
  bannerDetails?: BannersListDto;
  deleteBanner: () => void;
  handleSubmit: () => void;
}
const CreateOrEditBannerHeader = (props: ICreateOrEditBannerHeaderProps) => {
  const {
    bannerDetails,
    handleSubmit,
    isSubmitting,
    deleteBanner,
    saveAndContinue,
    setSaveAndContinue,
  } = props;

  const {messages} = useIntl();

  const navigate = useNavigate();

  const {locale}: any = useLocaleContext();

  const onSaveAndContinueEdit = (value?: boolean) => {
    setSaveAndContinue(value);
    handleSubmit();
  };

  return (
    <Row>
      <Col lg={12} sm={24}>
        <div className='text-title'>
          <span className='icon-title'>
            <FaTag />
          </span>
          {bannerDetails ? (
            `${messages['promotions.banners.editBannerDetails'].toString()} - ${
              bannerDetails?.Locales?.find(
                (item) => item.LanguageId === locale.code,
              )?.LocaleValue ?? bannerDetails?.Name
            }`
          ) : (
            <IntlMessages id='promotions.banners.addANewBanner' />
          )}
          <small className='back-to-list'>
            <BsFillArrowLeftCircleFill className='back-to-icon' />
            <a
              onClick={() => {
                navigate('/promotions/banners');
              }}>
              <IntlMessages id='promotions.banners.backToBannerList' />
            </a>
          </small>
        </div>
      </Col>
      <Col lg={12}>
        <Row justify='end' gutter={[20, 0]}>
          <Col>
            <Button
              icon={<BsCheckLg className='add-button-icon' />}
              onClick={() => onSaveAndContinueEdit(false)}
              type='primary'
              size='small'
              className='add-button'
              loading={saveAndContinue ? false : isSubmitting}>
              <IntlMessages id='common.save' />
            </Button>
          </Col>

          <Col>
            <Button
              icon={<BsCheckLg className='add-button-icon' />}
              onClick={() => onSaveAndContinueEdit(true)}
              type='primary'
              size='small'
              className='add-button'
              loading={saveAndContinue ? isSubmitting : false}>
              <IntlMessages id='common.saveAndContinueEdit' />
            </Button>
          </Col>

          {bannerDetails && (
            <Col>
              <Button
                icon={<BsFillTrashFill className='add-button-icon' />}
                onClick={deleteBanner}
                size='small'
                className='add-button'>
                <IntlMessages id='common.delete' />
              </Button>
            </Col>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default CreateOrEditBannerHeader;
